module.exports = __webpack_public_path__ + "static/selected_coords_icon-9255b1d87f1d8d8b0a0338423e33e4f9.png";